import { render, staticRenderFns } from "./AudienceAdmissionForm.vue?vue&type=template&id=00edb2e5&scoped=true&"
import script from "./AudienceAdmissionForm.vue?vue&type=script&lang=js&"
export * from "./AudienceAdmissionForm.vue?vue&type=script&lang=js&"
import style0 from "./AudienceAdmissionForm.vue?vue&type=style&index=0&id=00edb2e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00edb2e5",
  null
  
)

export default component.exports